import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-110">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-111">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-112" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="relative w-full max-w-2xl max-h-[80vh] bg-[#162438] border border-gray-700 rounded-2xl shadow-2xl overflow-hidden z-10" data-id="element-113">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-700 bg-[#0F1B2D]" data-id="element-114">
              <h2 className="text-xl font-bold text-[#FAFAF5]" data-id="element-115">{title}</h2>
              <button onClick={onClose} className="w-9 h-9 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-white/10 transition-colors" aria-label="Close" data-id="element-116">
                <X className="w-5 h-5" data-id="element-117" />
              </button>
            </div>

            {/* Content */}
            <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-64px)] text-gray-300 text-sm leading-relaxed space-y-4" data-id="element-118">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}